import { Injectable } from "@angular/core";
import { from, Observable, of } from "rxjs";

import { AwsAuthService } from "./aws-auth.service";
import { UserClaims } from "../interfaces/user-claims.interface";
import { switchMap } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class UserClaimsResolver  {
  constructor(private authService: AwsAuthService) {}

  resolve(): Observable<UserClaims | boolean> {
    return from(this.authService.isUserLoggedIn()).pipe(
      switchMap((loggedIn) => loggedIn ? from(this.authService.getCurrentUserClaims()) : of(false))
    )
  }
}